/**
 * Filter System Exports
 *
 * Re-exports all filter-related schemas, types, and utilities
 * for use throughout the monorepo.
 */

// Filter schemas and types
export {
  countActiveFilters,
  createDefaultInterviewFilterGroup,
  createEmptyFilterGroup,
  type FilterFieldType,
  filterFieldTypeSchema,
  type FilterGroup,
  filterGroupSchema,
  type FilterLogic,
  filterLogicSchema,
  // Types
  type FilterOperator,
  // Schemas
  filterOperatorSchema,
  type FilterRule,
  filterRuleSchema,
  // Filter value type and schema
  type FilterValue,
  filterValueSchema,
  generateFilterId,
  getDefaultOperator,
  getOperatorsForFieldType,
  hasActiveFilters,
  // Type guards for filter values (runtime validation)
  isEmptyValue,
  // Type guards for filter groups/rules
  isFilterGroup,
  isFilterRule,
  isNumberTupleValue,
  isNumberValue,
  isStringArrayValue,
  isStringValue,
  // Helper functions
  operatorRequiresValue,
  OPERATORS_BY_FIELD_TYPE,
  // Constants
  OPERATORS_WITHOUT_VALUE,
  // Validation helpers
  validateFilterValueForOperator,
} from "./filter-schemas";

// Sort schemas and types
export {
  createInsightSortField,
  // Constants
  DEFAULT_INTERVIEW_SORT,
  extractInsightIdFromSortField,
  type InterviewSortField,
  interviewSortFieldSchema,
  // Helper functions
  isInsightSortField,
  type MultiSortConfig,
  multiSortConfigSchema,
  type SortConfig,
  sortConfigSchema,
  sortConfigToTanstackSorting,
  // Types
  type SortOrder,
  // Schemas
  sortOrderSchema,
  tanstackSortingToSortConfig,
} from "./sort-schemas";

// Interview table input schemas
export {
  type DeviceTypeFilter,
  deviceTypeSchema,
  // Types
  type InterviewStatusFilter,
  // Schemas
  interviewStatusSchema,
  type PaginationResponse,
  paginationResponseSchema,
  // Panel schema
  type PanelInterviewTableInput,
  panelInterviewTableInputSchema,
  type QueryMetadata,
  queryMetadataSchema,
} from "./interview-table-input";

// Study table input schemas
export {
  // Types
  type InternalStudyTableInput,
  // Schemas
  internalStudyTableInputSchema,
  studyFilterFieldDefinitions,
  type StudyFilterFieldId,
  type StudyPaginationResponse,
  studyPaginationResponseSchema,
  type StudyStatusFilter,
  studyStatusFilterSchema,
  UNASSIGNED_OWNER_FILTER_ID,
} from "./study-table-input";

// Organization table input schemas
export {
  type InternalOrganizationFilterGroup,
  internalOrganizationFilterGroupSchema,
  type InternalOrganizationFilterRule,
} from "./organization-table-input";
